let baseURL = "/";

if (process.env.NODE_ENV === "development") {
  baseURL = "https://dev-api.talantahrm.com/";
} else {
  baseURL = "https://dev-api.talantahrm.com/";
}

const config = {
  baseURL,
};

export default config;
